import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function LoadingCard() {
  return (
    <div className="use-case-media-card use-case-media-card--in-grid">
      <div className="use-case-media-card--loading">
        <Spinner />
      </div>
    </div>
  )
}

export default LoadingCard
